<template>
  <section class="page-container">
    <el-dialog
      title="Popular brands"
      :visible.sync="isShow"
      :close-on-click-modal="false"
      width="80%"
    >
      <!--工具条-->
      <div ref="toolbar" class="toolbar">
        <el-form :inline="true" :model="filters">
          <el-form-item>
            <el-select v-model="filters.rootCatId" placeholder="顶级分类" clearable @change="list">
              <el-option
                v-for="item in rootCats"
                :key="item.id"
                style="width: 400px"
                :value="item.id"
                :label="item.name"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="list">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleAdd">新增</el-button>
          </el-form-item>
        </el-form>
      </div>

      <!--列表-->
      <div ref="mainContent" :style="{ height: mainHeight }">
        <el-table
          v-loading="listLoading"
          height="100%"
          :data="results"
          highlight-current-row
          border
          stripe
          size="mini"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="id" label="ID"></el-table-column>
          <el-table-column prop="rootCatId" label="顶级分类ID"></el-table-column>
          <el-table-column prop="rootCatName" label="顶级名称"></el-table-column>
          <el-table-column prop="rootCatImage" label="顶级分类图片">
            <template slot-scope="scope">
              <el-image
                v-if="scope.row.rootCatImage"
                style="width: 50px; height: 50px"
                :src="scope.row.rootCatImage"
                :preview-src-list="[scope.row.rootCatImage]"
                fit="cover"
              >
              </el-image>
            </template>
          </el-table-column>
          <el-table-column prop="catId" label="分类ID"></el-table-column>
          <el-table-column prop="catName" label="分类名称"></el-table-column>
          <el-table-column prop="catImage" label="分类图片">
            <template slot-scope="scope">
              <el-image
                style="width: 50px; height: 50px"
                :src="scope.row.catImage"
                :preview-src-list="[scope.row.catImage]"
                fit="cover"
              >
              </el-image>
            </template>
          </el-table-column>
          <el-table-column prop="sort" label="排序"></el-table-column>
          <el-table-column prop="createTime" label="创建时间">
            <template slot-scope="scope">{{ scope.row.createTime | formatDate }}</template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-dropdown type="primary" @command="handleCommand">
                <el-button type="primary" size="mini">
                  操作<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <!-- <el-dropdown-item
                    :command="{ type: 'edit', index: scope.$index, data: scope.row }"
                    >编辑</el-dropdown-item
                  > -->
                  <el-dropdown-item
                    :command="{ type: 'delete', index: scope.$index, data: scope.row }"
                    >删除</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 分页 -->
      <my-pagination
        ref="pagebar"
        :page="page"
        @current-change="handlePageChange"
        @size-change="handleLimitChange"
      />
    </el-dialog>

    <!--新增界面-->
    <el-dialog
      title="Add Popular Brands"
      width="80%"
      :visible.sync="addFormVisible"
      :close-on-click-modal="false"
    >
      <el-form ref="addForm" :model="addForm" label-width="120px">
        <el-form-item label="顶级分类">
          <el-select v-model="addForm.rootCatId" @change="loadCategories">
            <el-option
              v-for="item in rootCats"
              :key="item.id"
              style="width: 400px"
              :value="item.id"
              :label="item.name"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="分类">
          <el-cascader
            v-model="addForm.catId"
            style="width: 400px"
            :options="categories"
            filterable
            :props="{ expandTrigger: 'hover', value: 'id', label: 'name' }"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="addForm.sort" placeholder="越小越靠前"></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button type="primary" :loading="addLoading" @click.native="addSubmit">提交</el-button>
      </div>
    </el-dialog>

    <!--编辑界面-->
    <el-dialog title="编辑" :visible.sync="editFormVisible" :close-on-click-modal="false">
      <el-form ref="editForm" :model="editForm" label-width="120px">
        <el-input v-model="editForm.id" type="hidden"></el-input>
        <el-form-item label="id">
          <el-input v-model="editForm.id"></el-input>
        </el-form-item>
        <el-form-item label="catId">
          <el-input v-model="editForm.catId"></el-input>
        </el-form-item>
        <el-form-item label="sort">
          <el-input-number v-model="editForm.sort" placeholder="越小越靠前"></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button type="primary" :loading="editLoading" @click.native="editSubmit">提交</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import MyPagination from "@/components/MyPagination";
// import mainHeight from "@/utils/mainHeight";
export default {
  name: "PopularBrand",
  components: { MyPagination },
  data() {
    return {
      isShow: false,
      mainHeight: "600px",
      results: [],
      listLoading: false,
      page: {},
      filters: {},
      selectedRows: [],

      addForm: {},
      addFormVisible: false,
      addLoading: false,

      editForm: {},
      editFormVisible: false,
      editLoading: false,

      rootCats: [],
      categories: [],
    };
  },
  mounted() {
    // mainHeight(this);
    // this.list();
  },
  methods: {
    async show() {
      this.isShow = true;
      await this.list();
    },
    async list() {
      await this.loadRootCats();
      this.listLoading = true;
      const params = Object.assign(this.filters, {
        page: this.page.page,
        limit: this.page.limit,
      });
      try {
        const data = await this.axios.form("mall:/api/admin/popular-brand/list", params);
        this.results = data.results;
        this.page = data.page;
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      } finally {
        this.listLoading = false;
      }
    },
    handleCommand(cmd) {
      switch (cmd.type) {
        case "edit":
          this.handleEdit(cmd.index, cmd.data);
          break;
        case "delete":
          this.deleteSubmit(cmd.index, cmd.data);
          break;
        default:
          break;
      }
    },
    async handleAdd() {
      this.addForm = {};
      this.addFormVisible = true;
      await this.loadRootCats();
    },
    async loadRootCats() {
      this.rootCats = await this.axios.get("mall:/api/admin/product-category/rootCats");
    },
    async loadCategories() {
      this.addForm.catId = [];
      this.categories = await this.axios.get("mall:/api/admin/product-category/children", {
        params: {
          rootCatId: this.addForm.rootCatId,
        },
      });
      console.log(this.addForm);
    },
    async addSubmit() {
      this.addLoading = true;
      try {
        await this.axios.form("mall:/api/admin/popular-brand/create", {
          rootCatId: this.addForm.rootCatId,
          catId:
            this.addForm.catId && this.addForm.catId.length
              ? this.addForm.catId[this.addForm.catId.length - 1]
              : 0,
          sort: this.addForm.sort || 0,
        });
        this.$message({ message: "提交成功", type: "success" });
        this.addFormVisible = false;
        await this.list();
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      } finally {
        this.addLoading = false;
      }
    },
    async handleEdit(index, row) {
      try {
        const data = await this.axios.get("mall:/api/admin/popular-brand/" + row.id);
        this.editForm = Object.assign({}, data);
        this.editFormVisible = true;
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      }
    },
    async editSubmit() {
      this.editLoading = true;
      try {
        await this.axios.post("mall:/api/admin/popular-brand/update", this.editForm);
        await this.list();
        this.editFormVisible = false;
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      } finally {
        this.editLoading = false;
      }
    },
    async deleteSubmit(index, row) {
      const me = this;
      this.$confirm("是否确认删除?", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios
            .delete("mall:/api/admin/popular-brand/" + row.id)
            .then((data) => {
              me.$message({ message: "删除成功", type: "success" });
              me.list();
            })
            .catch((rsp) => {
              me.$elnotify.error({ title: "error ", message: rsp.message });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    async handlePageChange(val) {
      this.page.page = val;
      await this.list();
    },
    async handleLimitChange(val) {
      this.page.limit = val;
      await this.list();
    },
    handleSelectionChange(val) {
      this.selectedRows = val;
    },
  },
};
</script>

<style lang="scss" scoped></style>
